import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const quickLinks = [
  { to: '/', label: '网站首页' },
  { to: '/category', label: '全部漫画' },
  { to: '/category/romance', label: '恋爱漫画' },
  { to: '/category/fantasy', label: '奇幻漫画' },
  { to: '/about', label: '关于我们' },
];

export default function Footer() {
  const hotComics = comics.slice(0, 4);

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl text-foreground-950">
              布丁漫画网
            </span>
          </div>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            布丁漫画网是一家专注于中文漫画在线免费阅读的平台，收录《寄宿日记》等千余部热门作品，每日更新，畅读全集中文版本。
          </p>
          <div className="mt-4 flex items-center gap-2">
            <a
              href="https://weibo.com"
              target="_blank"
              rel="nofollow noopener"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
              aria-label="布丁漫画网微博"
            >
              <i className="ri-weibo-fill"></i>
            </a>
            <a
              href="#"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
              aria-label="布丁漫画网微信公众号"
            >
              <i className="ri-wechat-fill"></i>
            </a>
            <a
              href="mailto:contact@pudingmh.com"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
              aria-label="联系布丁漫画网"
            >
              <i className="ri-mail-fill"></i>
            </a>
          </div>
        </div>

        <nav aria-label="页脚导航">
          <h4 className="text-sm font-semibold text-foreground-900">
            快速导航
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {quickLinks.map((item) => (
              <li key={item.label + item.to}>
                <Link
                  to={item.to}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="热门作品">
          <h4 className="text-sm font-semibold text-foreground-900">
            热门作品
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {hotComics.map((comic) => (
              <li key={comic.id}>
                <Link
                  to={`/comic/${comic.id}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  《{comic.title}》
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">
            联系我们
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
            <li className="flex items-center gap-2">
              <i className="ri-mail-fill text-primary-500"></i>
              <span>contact@pudingmh.com</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-wechat-fill text-secondary-600"></i>
              <span>公众号：布丁漫画</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-2-fill text-accent-500"></i>
              <span>中国 · 杭州 · 文一西路 100 号</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-foreground-500"></i>
              <span>客服在线：每日 9:00 - 22:00</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-foreground-600 sm:flex-row md:px-6">
          <p>© 2026 布丁漫画网 · 保留所有权利</p>
          <p className="text-center">
            本站内容仅供学习交流使用，请支持正版漫画 · 侵权内容请联系我们删除
          </p>
        </div>
      </div>
    </footer>
  );
}